import { useFilterHighlight } from "../context/FilterHighlightContext";

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default function HighlightText({ text }: { text: string }) {
  const query = useFilterHighlight();

  if (!query || !query.trim()) return <>{text}</>;

  const escaped = escapeRegExp(query.trim());
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));

  return (
    <span style={{ display: "inline" }}>
      {parts.map((part, i) =>
        part.toLowerCase() === query.trim().toLowerCase() ? (
          <mark
            key={i}
            style={{
              backgroundColor: "rgba(253, 224, 71, 0.6)",
              borderRadius: 2,
              color: "inherit",
            }}
          >
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
}
